import i18n from 'i18next';
// @ts-ignore no types
import ICU from 'i18next-icu';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
// import locale-data for needed lngs
import de from 'i18next-icu/locale-data/de';
export default function initializeI18Next(translationVersion) {
    return i18n
        .use(new ICU({
        localeData: de // you also can pass in array of localeData
    }))
        .use(Backend)
        .use(LanguageDetector)
        .use(initReactI18next) // bind react-i18next to the instance
        .init({
        fallbackLng: 'de-DE',
        debug: false,
        ns: ['translation'],
        defaultNS: 'translation',
        backend: {
            loadPath: "/locales/{{lng}}/{{ns}}.json?v=" + translationVersion,
        },
        react: {
            useSuspense: false,
        },
        interpolation: {
            escapeValue: false, // not needed for react!!
        },
        // react i18next special options (optional)
        // override if needed - omit if ok with defaults
        /*
        react: {
          bindI18n: 'languageChanged',
          bindI18nStore: '',
          transEmptyNodeValue: '',
          transSupportBasicHtmlNodes: true,
          transKeepBasicHtmlNodesFor: ['br', 'strong', 'i'],
          useSuspense: true,
        }
        */
    });
}
//# sourceMappingURL=I18nextSetup.js.map